import AnalyticsDashboard from './AnalyticsDashboard';

export default AnalyticsDashboard;
